import React from 'react';
import GeometryDiagram from './GeometryDiagram';
import CoordinateGrid from './CoordinateGrid';
import Shape3D from './Shape3D';
import DataChart from './DataChart';
import TrigDiagram from './TrigDiagram';
import './DiagramStyles.css';

const MathDiagram = ({ data }) => {
  if (!data) return null;

  let parsed;
  try {
    parsed = typeof data === 'string' ? JSON.parse(data) : data;
  } catch (e) {
    console.warn('MathDiagram: Failed to parse diagram data', e);
    return null;
  }

  if (!parsed || !parsed.type) return null;

  const componentMap = {
    geometry: GeometryDiagram,
    coordinate: CoordinateGrid,
    shape3d: Shape3D,
    chart: DataChart,
    trig: TrigDiagram
  };

  const Component = componentMap[parsed.type];

  if (!Component) {
    console.warn(`MathDiagram: Unknown diagram type "${parsed.type}"`);
    return null;
  }

  return (
    <div className="math-diagram-wrapper">
      <Component data={parsed} />
      {parsed.caption && (
        <p className="diagram-caption">{parsed.caption}</p>
      )}
    </div>
  );
};

export default MathDiagram;
